"use strict";
var urls = require('common/urls');
var hlp = require('common/helpers');
var META_FIELD_NAME = 'metadata';
var open = function(archivnr, dianr) {
  var newwindow = window.open("/dia/" + archivnr + "?dia=" + dianr, 'diaviewer', 'height=1080,width=1920');
  if (hlp.isSet(newwindow)) {
    newwindow.focus();
  }
  return newwindow;
};
var placeholderPath = urls.imageStaticPath + "/placeholder.jpg";
var thumbnailUrl = function(work, width, height) {
  if (typeof(width) == 'undefined' && typeof(height) == 'undefined') {
    width = 32;
    height = 32;
  }
  if (typeof work[META_FIELD_NAME] != 'undefined' && typeof work[META_FIELD_NAME].dianr != 'undefined') {
    for (var i = 0; i < work[META_FIELD_NAME].dianr.length; i++) {
      var dianr = work[META_FIELD_NAME].dianr[i];
      if (typeof dianr.flags != 'undefined' && dianr.flags.primary == true) {
        return urls.thumbnailUrl(work.dianr[i], width, height);
      }
    }
  }
  if (typeof work.dianr != 'undefined' && work.dianr.length > 0) {
    return urls.thumbnailUrl(work.dianr[0], width, height);
  }
  return placeholderPath;
};
module.exports = {
  open: open,
  thumbnailUrl: thumbnailUrl
};
